/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useRef } from "react";
import {
  Badge,
  Button,
  Combobox,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { CircleX, SlidersHorizontal } from "lucide-react";

import {
  useLookupCashCenters,
  useLookupCustomers,
  useLookupMachinesServicePoints,
} from "services/lookups-mutations";

const PERIODS = [
  { id: "Today", text: "Today" },
  {
    id: "All",
    text: "All",
  },
  { id: "Yesterday", text: "Yesterday" },

  {
    id: "This Week",
    text: "This Week",
  },
  {
    id: "Last Week",
    text: "Last Week",
  },
  {
    id: "This Month",
    text: "This Month",
  },
];
export default function TicketsFilterBarV2({ getList = () => {} }) {
  const [filters, setFilters] = useState({});
  const [selectedCashCenter, setSelectedCashCenter] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  const [selectedDate, setSelectedDate] = useState("Today");

  const [filter, setFilter] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const filterTimeout = useRef(null);

  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();
  const { mutate: getCustomers, data: customersList } = useLookupCustomers();

  const {
    mutate: getLocations,
    data: locationsList,
    reset: resetLocations,
  } = useLookupMachinesServicePoints();

  useEffect(() => {
    getCashCenters();
    getCustomers();
  }, []);

  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        getList(
          filter || "",
          selectedDate,
          selectedCashCenter || "",
          selectedCustomer || "",
          selectedLocation || ""
        );
        handleAddFilter("filter", filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);
  useEffect(() => {
    if (!firstLoad) {
      getList(
        filter || "",
        selectedDate,
        selectedCashCenter || "",
        selectedCustomer || "",
        selectedLocation || ""
      );
    } else {
      setFirstLoad(false);
    }
  }, [selectedCashCenter, selectedCustomer, selectedLocation, selectedDate]);
  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    if (key === "cashCenter") {
      setSelectedCashCenter("");
    } else if (key === "customer") {
      setSelectedCustomer("");
      setSelectedLocation("");
      delete updatedFilter.asset;
    } else if (key === "asset") {
      setSelectedLocation("");
    } else if (key === "date") {
      setSelectedDate(new Date());
    } else if (key === "filter") {
      setFilter("");
    }
    setFilters({ ...updatedFilter });
  };
  const handleAddFilter = (key, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    const updatedFilter = { ...filters };

    updatedFilter[key] = `${name}: ${value}`;
    setFilters({ ...updatedFilter });
  };
  const clearAllFilters = () => {
    setFilters({});
    setSelectedCashCenter("");
    setSelectedCustomer("");
    setSelectedDate(new Date());
    setSelectedLocation("");
    setFilter("");
  };

  return (
    <>
      <div className="flex mb-3 gap-1">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="secondary" className="w-max" title="Apply Filters">
              <SlidersHorizontal />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-[540px]">
            <h6 className="font-semibold text-lg">Apply Filters</h6>
            <div className="grid grid-cols-2 gap-2 mt-3">
              <Combobox
                placeholder="Select Cash Center"
                data={[
                  { label: "Select Cash Center", value: "" },
                  ...((cashCentersList?.data || []).map((elm) => ({
                    label: elm.name,
                    value: elm.cashCenterId,
                  })) || []),
                ]}
                value={selectedCashCenter}
                setValue={(value) => {
                  setSelectedCashCenter(value);
                  let name = "";
                  if (value !== "") {
                    name = cashCentersList?.data.filter(
                      (elm) => elm.cashCenterId === value
                    )[0].name;
                  }
                  handleAddFilter("cashCenter", name, "Cash Center");
                }}
              />
              <Combobox
                placeholder="Select Customer"
                data={[
                  { label: "Select Customer", value: "" },
                  ...((customersList?.data || []).map((elm) => ({
                    label: elm.name,
                    value: elm.customerId,
                  })) || []),
                ]}
                value={selectedCustomer}
                setValue={(value) => {
                  setSelectedCustomer(value);
                  let name = "";
                  if (value !== "") {
                    name = customersList?.data.filter(
                      (elm) => elm.customerId === value
                    )[0].name;
                  }
                  handleAddFilter("customer", name, "Customer");
                  setSelectedLocation("");
                  if (value) {
                    getLocations(value);
                  } else {
                    resetLocations();
                  }
                }}
              />

              <Combobox
                placeholder="Select Asset"
                data={[
                  { label: "Select Asset", value: "" },
                  ...(locationsList?.data.map((elm) => ({
                    label: elm.locationId,
                    value: elm.servicePointId,
                  })) || []),
                ]}
                value={selectedLocation}
                setValue={(value) => {
                  let name = "";
                  if (value !== "") {
                    name = locationsList?.data.filter(
                      (elm) => elm.servicePointId === value
                    )[0].locationId;
                  }
                  handleAddFilter("asset", name, "Asset");
                  setSelectedLocation(value);
                }}
              />
            </div>
          </PopoverContent>
        </Popover>

        <div className="min-w-[15%] ">
          <Select
            onValueChange={(e) => {
              setSelectedDate(e);
            }}
            value={selectedDate}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {PERIODS.map((elm, index) => (
                <SelectItem key={index} value={elm.id}>
                  {elm.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search: Task No, Case No, Status, Activity Type, Category, Sub Category, Bank Reference No"
            title="Search: Task No, Case No, Status, Activity Type, Category, Sub Category, Bank Reference Number"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
            key={key}
          >
            {value}
            <CircleX
              onClick={() => {
                handleClearFilter(key);
              }}
            />
          </Badge>
        ))}
        {Object.keys(filters).length > 0 ? (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX
              onClick={() => {
                clearAllFilters();
              }}
            />
          </Badge>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
